/*
 * @see [Documentation](https://nuxt-graphql-middleware.dulnan.net/advanced/templates#client-options)
 */
export const clientOptions = {}